<script>
import { setCookie, getCookie } from '@/utils/cookie'
import RouteMixin from '@/mixins/route'

export default {
  name: 'tour',
  methods: {
    startTour() {
      this.$tour.getCalloutManager().removeAllCallouts()
      this.$tour.startTour(this.tour)
    }
  },
  mounted() {
    // This is specifically for dashboard (to check 1st access to application)
    if (this.isMatchRouteExact('dashboard')) {
      if (getCookie('firstEntry') === null) {
        this.$tour.getCalloutManager().createCallout({
          id: 'guideBtn',
          target: 'guideBtn',
          placement: 'left',
          title: 'Guide',
          content: 'If you are new to the System, consider taking the Quick Tour!'
        })
      }
      setCookie('firstEntry', 'true')
    }
    if (this.isMatchRouteExact('claimRegister')) {
      if (getCookie('firstEntryClaim') === null) {
        this.$tour.getCalloutManager().createCallout({
          id: 'guideRegisterClaimBtn',
          target: 'guideRegisterClaimBtn',
          placement: 'left',
          title: 'Guide',
          content: 'If you are new to the first time enter a new Claim, consider taking the Quick Tour!'
        })
      }
      setCookie('firstEntryClaim', 'true')
    }
  },
  beforeDestroy() {
    this.$tour.getCalloutManager().removeAllCallouts()
    this.$tour.endTour()
  },
  props: {
    tour: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [
    RouteMixin
  ],
  render(h) {
    return null
  }
}
</script>

<style lang="scss">

</style>
